"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const products_1 = require("@/store/ducks/products");
const listAssociatedComponents_1 = require("@/useCases/productsAssociation/listAssociatedComponents");
const index_view_1 = __importDefault(require("./index.view"));
function AssociateProductsSection() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { productId } = (0, react_router_dom_1.useParams)();
    react_1.default.useEffect(() => {
        (0, listAssociatedComponents_1.listAssociatedComponents)(productId)(dispatch);
    }, []);
    const [shouldShowComponentsTable, showComponentsTable] = react_1.default.useState(false);
    const onShowComponentsTable = react_1.default.useCallback(() => {
        showComponentsTable(!shouldShowComponentsTable);
        dispatch((0, products_1.onShowSavePrompt)());
    }, [products_1.onShowSavePrompt, dispatch, shouldShowComponentsTable]);
    return (react_1.default.createElement(index_view_1.default, { isExistingAssociation: !!productId, shouldShowComponentTable: shouldShowComponentsTable, onAssignComponent: onShowComponentsTable }));
}
exports.default = AssociateProductsSection;
